<template>
  <div class="wallet-cards container">
    <!-- <div class="row pb-3 justify-content-end title">
            <h6 class="col-md-6 text-left">12 search results for <strong>'Search function'</strong> </h6>
            <h6 class="col-md-6 text-right"><a href="#"> <strong>Sort <i class="mdi mdi-filter"></i></strong> </a>
            </h6> 
        </div> -->

    <div class="row justify-content-center">

      <div class="col-md-5 col-lg-4">
        <div class="card-bal highlight">
          <div class="text-center">
            <div class="title">{{$t('wallet.labels.WalletBalance')}}</div>
            <div class="bal">
              {{amount}} </div>
            <div class="info pt-20">
              {{$t('wallet.labels.YouHave')}} {{amount}} {{$t('common.alerts.POINTS_IN_WALLET')}}
            </div>
          </div>
          <div class="menu">

            <!-- <div class="pt-20">

                            <input type="number" class="form-control" placeholder="EnterAmount" v-model="amountToAdd">
                            <i class="mdi mdi-plus"></i> <br>
                            <button @click="addMoney()">Add Money</button>
                        </div> -->
            <div class="d-flex">
              <div class="pt-3">
                <i class="mdi mdi-currency-inr"></i>
                <span v-b-toggle.addmoney>
                  <a>{{$t('wallet.labels.AddMoneyInWallet')}}</a>
                </span>
                <!-- <div> -->
                <b-collapse id="addmoney" class="mt-2">
                  <div>
                    <div class="input-group">
                      <input type="number" class="form-control" :placeholder="$t('wallet.placeholders.EnterAmount')" v-model="amountToAdd">
                      <button class="input-group-addon btn btn-blue" @click="addMoney()" id="addm">Add</button>
                    </div>
                    <!-- <input type="number" class="form-control" placeholder="EnterAmount" v-model="amountToAdd">
                                      <button class="input-group-addon btn btn-blue" id="basic-addon2">Add money</button> -->
                  </div>
                </b-collapse>
                <!-- </div> -->
              </div>
            </div>
            <div class="d-flex">
              <div class="pt-2">
                <!-- <div> -->
                <i class="mdi mdi-email"></i>
                <!-- </div> -->
                <!-- <div> -->
                <a href="mailto:livedemysupport@mkcl.org?" target="_top">{{$t('wallet.labels.ContactUs')}}</a>
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-7">
        <div class="card-history">
          <div class="search-items">
            <div class="input-group">
              <input v-model="search" class="form-control" :placeholder="searchFor ? 'By activity title' :'By transaction id'">
              <button class="input-group-addon btn btn-gray" id="search-items">
                <i class="mdi mdi-magnify"></i>
              </button>
            </div>

          </div>
          <div class="tabs-css">
            <b-tabs><hr/>

              <b-tab @click="getActivities()" :title="$t('wallet.labels.Activities')" active>
                <div class="tab-content-holder" v-bar>
                  <div class="vbar-holder" v-if="filteredActivityList!= undefined && filteredActivityList.length > 0">
                    <div class="item item-adj" v-for="(activity,i) in filteredActivityList" :key="i">
                      <div class="row row-hover">
                        <div class="col align-self-center text-left">
                          <div class="i-title">{{activity.title}}</div>
                          <div class="i-details">{{$t('wallet.labels.WatchedFor')}} {{Math.round(((activity.duration)/60)*100)/100}} {{$t('wallet.labels.MinutesOn')}} {{activity.recentTime|moment("Do MMM, YYYY h:mm A")}}</div>
                        </div>
                        <div class="col align-self-center amount-text-align">
                          <div class="amount">
                            {{activity.price}} {{$t('wallet.labels.Points')}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="vbar-holder" v-else>
                     <p> Not enough activities have occurred to show</p>
                  </div>
                </div>
              </b-tab>
              <b-tab @click="getTransactionData()" :title="$t('wallet.labels.Transactions')" class="transaction">
                <div class="tab-content-holder" v-bar>
                  <div class="vbar-holder" v-if="filteredWalletList!= undefined && filteredWalletList.length > 0">
                    <div class="item" v-for="(transaction,i) in filteredWalletList" :key="i">
                      <div class="row row-hover align-items-center mb-3">
                        <!-- <div class="col-auto">
                          <div class="transaction-type">
                            <i v-if="transaction.walletTransType=='OUT'" class="mdi mdi-chevron-left"></i>
                            <i v-else class="mdi mdi-chevron-right"></i>
                          </div>
                        </div> -->
                        <div class="col align-self-center text-left">
                          <div class="badge badge-success-alt" v-bind:class="{ 'badge-success-alt': transaction.status==='SUCCESS', 'badge-danger-alt': transaction.status==='FAILED', 'badge-pending-alt': transaction.status==='PENDING' }">{{transaction.status}}</div>
                          <div class="i-title" v-if="transaction.status==='FAILED'">
                            {{$t('wallet.labels.FailedToAddMsg')}} {{transaction.transactionDate|moment("Do MMM, YYYY h:mm A")}}
                            <div class="i-details">{{$t('common.labels.TRANSACTION_ID')}} {{transaction.cartId}}</div>
                          </div>
                          <div class="i-title" v-else-if="transaction.walletTransType=='IN'">
                            {{$t('wallet.labels.AddedToWalletOn')}} {{transaction.transactionDate|moment("Do MMM, YYYY h:mm A")}}
                            <div class="i-details">{{$t('common.labels.TRANSACTION_ID')}} {{transaction.cartId}}</div>
                          </div>
                          <div class="i-title" v-else>
                            {{$t('wallet.labels.PurchaseMadeOn')}} {{transaction.transactionDate|moment("Do MMM, YYYY h:mm A")}}
                            <div class="i-details">{{$t('common.labels.TRANSACTION_ID')}} {{transaction.cartId}}</div>
                          </div>

                        </div>
                        <div class="col-auto align-self-center text-right">
                          <div class="amount">
                            <i class="mdi mdi-currency-inr"></i>{{transaction.amount}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="vbar-holder" v-else>
                     <p> Transaction details are not available</p>
                  </div>
                </div>
              </b-tab>

              <!-- <b-tab title="Win Offers" class="offers">
                                <div class="item">
                                    <div class="row">
                                        <div class="col-8 align-self-center">
                                            <div class="i-title">Update your wallet balance instantly!</div>
                                            <div class="i-details">Valid till 23 Jan 18</div>
                                        </div>
                                        <div class="col-4 align-self-center text-right">
                                            <button class="btn btn-indigo btn-large">Try your luck</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="item">
                                    <div class="row">
                                        <div class="col-8 align-self-center">
                                            <div class="i-title">Unlock free courses</div>
                                            <div class="i-details">Valid till 31 Jan 18</div>
                                        </div>
                                        <div class="col-4 align-self-center text-right msg">Better luck next time</div>
                                    </div>
                                </div>
                                <div class="item">
                                    <div class="row">
                                        <div class="col-8 align-self-center">
                                            <div class="i-title">Update your wallet balance</div>
                                            <div class="i-details">Valid till 31 Jan 18</div>
                                        </div>
                                        <div class="col-4 align-self-center text-right msg">You've won
                                            <i class="mdi mdi-currency-inr"></i>70</div>
                                    </div>
                                </div>
                            </b-tab> -->

            </b-tabs>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-4 col-sm-12">
                <div class="card">
                    <span class="title">Add money</span>
                </div>
            </div> -->
    </div>
    <form :action=url method="POST" id="upsForm" name="upsForm">
      <input name="upsString" v-model="upsString" type="hidden" id="someId">
      <input name="reqFrom" value="goLang" type="hidden">
    </form>
  </div>
</template>

<script>
import * as cons from '../common/constants.js'
import axios from 'axios'
import lodash from 'lodash'
export default {
  name: 'walletCards',
  components: {},
  data () {
    return {
      amount: 0,
      search: '',
      walletId: '',
      amountToAdd: '',
      walletTransList: [],
      activityList: [],
      upsString: '',
      url: cons.PAYMENT_REQUEST_URL,
      transactionTime: '',
      searchFor: true
    }
  },
  created () {
    this.getWalletAmount()
    this.getActivities()
  },
  methods: {
    addMoney () {
      if (this.amountToAdd === '' || this.amountToAdd <= '0') {
        this.$toasted.error(this.$t('wallet.alerts.EnterValidAmount'))
        return
      }
      axios
        .post('r/wallet/purchaseHistory', {
          profileId: this.$store.getters.getProfileDetails.profileId,
          walletId: this.walletId,
          totalAmount: parseInt(this.amountToAdd)
        })
        .then(res => {
          if (res.data !== '') {
            this.upsString = res.data
            this.submitUpsForm()
            // this.getWalletAmount()
          } else {
            alert('Error')
          }
        })
        .catch(err => {
          console.log('Error in Updating wallet Amount', err)
        })
    },
    submitUpsForm () {
      // console.log('this.upsString >> ' + this.upsString)
      document.getElementById('someId').value = this.upsString
      document.getElementById('upsForm').submit()
    },
    getWalletAmount () {
      return new Promise((resolve, reject) => {
        axios
          .post('r/wallet/getWalletDetailsbyUser', {
            profileId: this.$store.getters.getProfileDetails.profileId
          })
          .then(res => {
            this.amount = res.data.totalAmount
            this.walletId = res.data.walletId
            resolve(this.amount)
          })
          .catch(err => {
            console.log('Error in getting Wallet details', err)
            reject()
          })
      })
      // return this.amount
    },
    getTransactionData () {
      return new Promise((resolve, reject) => {
        axios
          .post('r/walletTransaction/getUserWalletTransactions', {
            profileId: this.$store.getters.getProfileDetails.profileId,
            walletId: this.walletId
          })
          .then(res => {
            this.searchFor = false
            this.walletTransList = res.data
            lodash.reverse(this.walletTransList)
            resolve()
          })
          .catch(err => {
            console.log('Error in Getting Transaction Data', err)
            reject()
          })
      })
    },
    getActivities () {
      return new Promise((resolve, reject) => {
        axios
          .post('r/GetLOActivityRoute', {
            profileId: this.$store.getters.getProfileDetails.profileId
          })
          .then(res => {
            this.searchFor = true
            this.activityList = lodash.orderBy(res.data, 'recentTime', 'desc')
            resolve()
          })
          .catch(err => {
            console.log('Error in Getting Activities Data', err)
            reject()
          })
      })
    }
  },
  computed: {
    filteredWalletList () {
      return this.walletTransList.filter(wallet => {
        return wallet.status.toLowerCase().includes(this.search.toLowerCase()) || wallet.cartId.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    filteredActivityList () {
      return this.activityList.filter(activity => {
        return activity.title.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  }
}
</script>
<style lang="scss">
@import '../../../static/assets/styles/scss/variables.scss';

.warp {
  height: 80px;
  overflow: hidden;
}

.tab-content-holder {
  height: 250px;
}
.wallet-cards {
  padding-top: 50px;
  padding-bottom: 20px;

  /*The Wrapper*/
  .myscrollbar {
    max-height: 281px;
  }
  #addmoney {
    .input-group {
      input {
        font-size: 13px;
        box-shadow: none;
      }
    }
  }
  %card {
    .title {
      font-family: $opensans;
      padding-bottom: 20px;
      font-weight: 600;
      font-size: 18px;
    }
    .mdi {
      font-size: 14px;
      padding-right: 10px;
    }
    border-radius: 3px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.18);
    border: none;
    background-color: #fff;
    transition: box-shadow 0.25s;
    margin-bottom: 35px;
    padding: 35px;
  }
  .card-bal {
    @extend %card;
    min-height: 387px;
    .bal {
      .mdi {
        font-size: 24px;
        color: #61bfee; /*non-webkit fallback*/
        background: linear-gradient(80deg, #61bfee, #af96fa);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      padding-top: 22px;
      padding-bottom: 22px;
      color: #61bfee; /*non-webkit fallback*/
      line-height: 70px;
      font-size: 5em;
      background: -webkit-linear-gradient(80deg, #61bfee, #af96fa);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .info {
      padding-bottom: 20px;
      color: #999;
    }
    .menu {
      font-size: 14px;
      padding-top: 18px;
      a {
        color: #333;
        &:hover {
          text-decoration: underline;
        }
      }
      .pt-20 {
        margin-top: 20px;
      }
      .d-flex {
        padding-top: 0px;
      }
    }
  }
  .card-history {
    @extend %card;
    position: relative;
    .search-items {
      position: absolute;
      width: 200px;
      right: 40px;
      top: 25px;
      .input-group {
        input {
          box-shadow: none;
          outline: 0px;
           background-color: #eee;
          border: none;
        }
        .btn-gray {
          box-shadow: none;
          outline: 0px;
           background-color: #eee;
          padding-right: 0px;
          color: #999;
        }
        .mdi{font-size:20px;}
        &:hover,
        &:focus,
        &:active {
          .btn-gray,
          input {
            color: #333;
          }
        }
      }
    }
    .tabs-css {
      .tab-content {
        min-height: 255px;
      }
      hr {
        margin-left: -35px;
        margin-right: -35px;
      }
      .nav-tabs {
        font-family: $opensans;
        padding-bottom: 10px;
        font-weight: 600;
        font-size: 18px;
        outline: 0;
        box-shadow: none;
        border: none;
        .nav-link {
          padding: 0px;
          margin-right: 40px;
          border: none;
          background-color: transparent;
          color: #96abb5;
          &:active {
            color: #464a4c;
            background-color: transparent;
          }
        }
        .nav-link.active {
          color: #333;
        }
      }
    }
    .item {
      padding-bottom: 20px;
      .amount {
        display: inline-block;
        font-size: 18px;
        // letter-spacing: 2px;
        padding: 15px 40px;
        text-align: center;
        width: 167px;
        // background: linear-gradient(to right, #85acf3 0%, rgb(107, 153, 238) 100%);
        // color: #85acf3;
      }
      .i-details {
        font-size: 12px;
        color: #999;
      }
      .i-title {
        font-weight: 500;
        font-size: 14px;
        color: #333;
      }

      .msg {
        font-weight: 600;
        .mdi {
          padding-right: 5px;
        }
      }
      .offers {
        .item {
          &:hover {
            .msg {
              color: rgb(101, 143, 221);
            }
          }
        }
      }
      .badge-success-alt {
        background: #9bc42b;
        padding: 4px 12px;
        font-size: 10px;
        text-transform: uppercase;
        color: #fff;
      }
      .badge-danger-alt {
        background: #e64747;
        padding: 4px 12px;
        font-size: 10px;
        text-transform: uppercase;
        color: #fff;
      }
      .badge-pending-alt {
        background: #e2874b;
        padding: 4px 12px;
        font-size: 10px;
        text-transform: uppercase;
        color: #fff;
      }
      // &:hover {
      //   .amount {
      //     background: linear-gradient(to right, #85acf3 0%, rgb(107, 153, 238) 100%);
      //     color: #fff;
      //     border-radius: 4px;
      //   }
      // }
    }
    .transaction {
      .i-details {
        font-weight: 500;
      }
    }
  }
  .highlight {
    transition: box-shadow 0.45s;
    box-shadow: 0px 10px 45px rgba(0, 0, 0, 0.25);
  }
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .transaction-type {
    width: 60px;
    height: 60px;
    border-radius: 50px;
    background: #61bfee;
    text-align: center;
    padding: 17px 18px;
    .mdi {
      font-size: 22px !important;
      color: #fff;
      &.mdi-chevron-left {
        transform: rotate(-45deg);
      }
      &.mdi-chevron-right {
        transform: rotate(-45deg);
      }
    }
  }
  .item-adj {
    padding-right: 15px;
  }
  .input-group-addon {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
   @media (max-width: 576px) {
  // .main-title {text-align:center;}
  .search-items{visibility: hidden;}
  .card-history{
    .amount-text-align{
      text-align:left;
    }
    .amount {
          background: linear-gradient(to right, #85acf3 0%, rgb(107, 153, 238) 100%);
          color: #fff;
          border-radius: 4px;
        }
      .item {
            padding-bottom: 45px;
        }
    }
  }
  @media (min-width: 577px) {
    // .main-title {text-align:left;}
    .search-items{visibility: visible;}
    .card-history{
    .amount-text-align{
      text-align:right;
    }
    .item {
      padding-bottom: 20px;
      .amount{
        color:#85acf3;
      }
    }
    .row-hover{
    &:hover {
        .amount {
          background: linear-gradient(to right, #85acf3 0%, rgb(107, 153, 238) 100%);
          color: #fff;
          border-radius: 4px;
        }
      }
    }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wallet/walletCards.vue?24c5e585